/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import {AbstractResourceService, JsonApiResource} from "@irian-ro/abstract-resource";
import { HttpClient } from "@angular/common/http";
import {EnvironmentService} from '@irian-ro/util-environment';
import {Observable} from "rxjs";
import {PlatformLegalEntityDTO} from "@well/platform-administration/company/domain";

@Injectable({
  providedIn: 'root'
})
export class PlatformLegalEntityResourceService extends AbstractResourceService<any, any, any, any>{
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('platformLegalEntityUrl'),
      undefined,
      undefined
    );
  }

  getActivePlatformLegalEntityTemplate() : Observable<JsonApiResource<PlatformLegalEntityDTO, any>>{
    return this.httpClient?.get(`${this.url}/active/template`).pipe(this.getDtoMapper());
  }

  override update(platformLegalEntityDTO: PlatformLegalEntityDTO) : Observable<JsonApiResource<PlatformLegalEntityDTO, any>> {
    return this.httpClient?.put(`${this.url}`, platformLegalEntityDTO).pipe(this.getDtoMapper());
  }

}
